import React, { useState } from 'react';
import Select, { InputActionMeta } from 'react-select';

export type MultiSelectOptionType<T> = {
  label: string;
  value: T;
};

type Props<T> = {
  onChange: (newValue: Array<MultiSelectOptionType<T>>) => void;
  values: Array<MultiSelectOptionType<T>>;
  options: Array<MultiSelectOptionType<T>>;
  name?: string;
  placeholder?: string;
  styles?: React.CSSProperties;
};

export const MultiSearchSelect = <T,>({ onChange, values, options, name, placeholder, styles }: Props<T>) => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  const handleInputChange = (inputValue: string, { action }: InputActionMeta) => {
    if (action !== 'set-value' && action !== 'input-blur') {
      setSearchTerm(inputValue);
    }
  };

  const handleOnChange = (newValue: Array<MultiSelectOptionType<T>>) => {
    onChange(newValue);
    setSearchTerm(searchTerm);
  };

  return (
    <div style={styles}>
      <Select
        isMulti
        name={name}
        onChange={handleOnChange}
        onInputChange={handleInputChange}
        value={values}
        inputValue={searchTerm}
        options={options}
        placeholder={placeholder}
        closeMenuOnSelect={false}
        filterOption={(option: MultiSelectOptionType<T>, inputValue: string) => {
          const { label } = option;
          return label.toLowerCase().startsWith(inputValue.toLowerCase());
        }}
      />
    </div>
  );
};
